import httpManager from '../../util/common'
import newsTypeLists from '../../../static/json/news_labels.json'
import { timestampToDate } from '../../util/util'
import Cookies from 'js-cookie'
export default{
  data () {
    return {
      news: {}
    }
  },
  computed: {
    locale () {
      return Cookies.get('locale') || 'zh'
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData() {
      const { query } = this.$route
      let params = new Map()
      params.set('news_id', query.news_id)
      httpManager('esg_news_detail', params)
        .then(res => {
          const { data } = res.data
          data[0].time = timestampToDate(data[0].ctime, true)
          if (data[0].company_info) {
            this.$set(data[0], 'company', [])
            data[0].company_info.forEach(ele => {
                data[0].company.push(ele.full_name[0])
            });
          }
          newsTypeLists[this.locale].forEach(el => {
            if (el.children) {
              el.children.forEach(val => {
                if (val.value == data[0].class) {
                  data[0].color = el.color
                  data[0].tag = val.title
                }
              })
            }
          })
          this.news = data[0]
        })
        .catch(error => {
          console.log(error)
        })
    }
  },
}


// WEBPACK FOOTER //
// ./src/esg/js/esg_public_sentiment_detail.js